import { Observable } from 'rxjs';

import { CreateCoachMeetingCmd } from 'task/command/create-coach-meeting.cmd';
import { CreateJobOfferMeetingCmd } from 'task/command/create-job-offer-meeting.cmd';
import { CreateTodoTaskCmd } from 'task/command/create-todo-task.cmd';
import { MoveTaskCmd } from 'task/command/move-task.cmd';
import { TaskOutput } from 'task/model/task.output';
import { FetchTasksQuery } from 'task/query/fetch-tasks.query';
import { ObserveSearchedUserCoachMeetingsQuery } from 'task/query/observe-searched-user-coach-meetings.query';

import { CreateContactMeetingCmd } from '../command/create-contact-meeting.cmd';

export abstract class TaskApiPort {
	public abstract createContactMeeting(
		cmd: CreateContactMeetingCmd
	): Observable<TaskOutput>;

	public abstract createJobOfferMeeting(
		cmd: CreateJobOfferMeetingCmd
	): Observable<TaskOutput>;

	public abstract fetchDayTasks(date: string): Observable<TaskOutput[]>;

	public abstract fetchContactTasks(contactId: string): Observable<TaskOutput[]>;

	public abstract fetchJobOfferTasks(
		jobOfferId: string
	): Observable<TaskOutput[]>;

	public abstract fetchTaskById(id: string): Promise<TaskOutput>;

	public abstract markTaskDone(id: string): Promise<TaskOutput>;

	public abstract markTaskPending(id: string): Promise<TaskOutput>;

	public abstract deleteTask(id: string): Promise<string>;

	public abstract fetchUserPendingTasks(
		userId: string
	): Observable<TaskOutput[]>;

	public abstract createCoachMeeting(
		cmd: CreateCoachMeetingCmd
	): Observable<TaskOutput>;

	public abstract createTodoTask(cmd: CreateTodoTaskCmd): Observable<TaskOutput>;

	public abstract moveTask(cmd: MoveTaskCmd): Observable<TaskOutput>;

	public abstract fetchTasks(query: FetchTasksQuery): Observable<TaskOutput[]>;

	public abstract fetchTasksByIds(ids: string[]): Promise<TaskOutput[]>;

	public abstract searchUserCoachMeetings(
		query: ObserveSearchedUserCoachMeetingsQuery
	): Observable<TaskOutput[]>;
}
